module.exports = __webpack_public_path__ + "static/media/mackbook.d70305cd.png";